var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content mb-4",attrs:{"id":"app"}},[_c('app-header'),_c('div',{staticClass:"container"},[_vm._m(0),_c('FundTransactionForm',{attrs:{"action-url":"/transfer"}})],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 text-center"},[_c('div',{staticClass:"amej-title"},[_c('h1',[_vm._v("Transfer Fund")])])])])
}]

export { render, staticRenderFns }